var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.email && _vm.user.isAdmin)?_c('admin-dashboard',{attrs:{"user":_vm.user}}):(_vm.user.subscription === 'extensive')?_c('user-dashboard',{attrs:{"user":_vm.user}}):_c('simple-user-dashboard',{attrs:{"user":_vm.user}})}
var staticRenderFns = []

export { render, staticRenderFns }